<template>
  <div>
    <el-dialog
      class="views-bulletin-components-page-preview"
      width="90%"
      title="預覽畫面"
      :visible.sync="isDialogVisible"
      destroy-on-close
    >
      <!-- <div class="views-bulletin-components-page-preview__button-wrapper">
        <el-button @click="openPage" round>預覽網頁</el-button>
      </div>-->
      <iframe
        v-resize="{ log: false }"
        class="views-bulletin-components-page-preview__iframe"
        width="100%"
        height="900"
        :src="url"
        frameborder="0"
        scrolling="yes"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: () => ({})
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDialogVisible: {
      get () {
        return this.isVisible
      },
      set (value) {
        this.$emit('update:isVisible', value)
      }
    }
  },
  methods: {
    openPage () {
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style lang="sass">
.views-bulletin-components-page-preview .el-dialog
  border-radius: 8px
  &__header
    border-top-left-radius: 8px
    border-top-right-radius: 8px
    background-color: $bgDark3
  &__title
    color: $mainFontColor
    font-size: map-get($fontSize,large)
    font-weight: bold
    line-height: 32px
  &__close
    font-size: 25px
    font-weight: bolder
    color: $subFontColor
  &__body
    text-align: center
    font-size: map-get($fontSize,small)
    padding: 35px 40px

.views-bulletin-components-page-preview__button-wrapper
  display: flex
  justify-content: flex-end
  margin-bottom: 20px

.views-bulletin-components-page-preview__iframe
  overflow: scroll
  overflow-x: hidden
</style>
